import { CommonModule } from '@angular/common';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgSelectModule } from '@ng-select/ng-select';
import {
  NgxMaskDirective,
  NgxMaskPipe,
  provideEnvironmentNgxMask,
} from 'ngx-mask';
import { AppComponent } from 'src/app/app.component';
import { SharedModule } from 'src/app/shared/shared.module';
import { HomeRoutingModule } from './home-routing.module';
import { PageComponent } from './page/page.component';
import { BalanceComponent } from './balance/balance.component';
import { CarouselButtonsComponent } from './carousel-buttons/carousel-buttons.component';
import { TransactionsComponent } from './transactions/transactions.component';
import { HomeService } from './home.service';
import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

@NgModule({
  declarations: [
    PageComponent,
    BalanceComponent,
    CarouselButtonsComponent,
    TransactionsComponent,
  ],
  imports: [
    CommonModule,
    NgSelectModule,
    FormsModule,
    ReactiveFormsModule,
    HomeRoutingModule,
    SharedModule,
    NgbModule,
    NgxMaskDirective,
    NgxMaskPipe,
    MatTableModule,
    MatSortModule,
    MatPaginatorModule,
    NgxSkeletonLoaderModule,
  ],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  providers: [provideEnvironmentNgxMask(), HomeService],
  exports: [],
  bootstrap: [AppComponent],
})
export class HomeModule {}
